// AdminTopBar.js
import React, { useState, useMemo } from "react";
import {
  AppBar, Toolbar, Typography, Button, Box, IconButton,
  Drawer, List, ListItemButton, ListItemText, Divider
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// ✅ ADD THIS
import { ThemeToggleButton } from "../theme/CustomThemeProvider";

const AdminTopBar = () => {
  const { user, role, logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const isAdmin = role === "admin" || (user?.roles || []).includes("admin");

  const links = useMemo(() => ([
    { label: "Dashboard", path: "/admin/dashboard" },
    { label: "Products", path: "/admin/products" },
    { label: "Users Stats", path: "/admin/users-stats" },
    { label: "Feedback", path: "/admin/feedback" },
    { label: "Analytics", path: "/admin/analytics-funnel" },
    { label: "Add Recipe", path: "/admin/add-recipe" },
    { label: "Add Product", path: "/admin/add-product" },
    { label: "Add Admin", path: "/admin/add-admin" },
  ]), []);

  const handleLogout = async () => {
    setDrawerOpen(false);
    await logout();
    navigate("/admin-login", { replace: true });
  };

  const DrawerList = (
    <Box sx={{ width: 260 }} role="presentation" onClick={() => setDrawerOpen(false)}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" fontWeight={800}>Admin</Typography>
        <Typography variant="body2" color="text.secondary">InCooking</Typography>
      </Box>
      <Divider />
      <List>
        {links.map((item) => (
          <ListItemButton key={item.path} component={Link} to={item.path}>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
        <Divider sx={{ my: 1 }} />
        <ListItemButton onClick={handleLogout}>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>
    </Box>
  );

  if (!isAdmin) return null;

  return (
    <AppBar position="sticky" color="default" elevation={2}>
      <Toolbar sx={{ gap: 1 }}>
        <Box
          component={Link}
          to="/admin/dashboard"
          sx={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}
        >
          <Box
            component="img"
            src="/logo.png"
            alt="InCooking"
            sx={{ height: 36, width: 36, mr: 1, borderRadius: 2, boxShadow: 2 }}
          />
          <Typography variant="h6" fontWeight={900} sx={{ whiteSpace: "nowrap" }}>
            Admin
          </Typography>
        </Box>

        {/* Desktop links */}
        <Box sx={{ display: { xs: "none", md: "flex" }, ml: "auto", gap: 1, alignItems: "center" }}>
          {links.slice(0, 4).map((item) => (
            <Button key={item.path} color="inherit" component={Link} to={item.path}>
              {item.label}
            </Button>
          ))}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {links.slice(4).map((item) => (
            <Button key={item.path} variant="outlined" color="inherit" component={Link} to={item.path}>
              {item.label}
            </Button>
          ))}

          {/* ✅ THEME TOGGLE HERE */}
          <ThemeToggleButton sx={{ ml: 1 }} />

          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        </Box>

        {/* Mobile menu */}
        <Box sx={{ display: { xs: "block", md: "none" }, ml: "auto" }}>
          {/* ✅ (προαιρετικά) δείξε toggle και στο mobile */}
          <ThemeToggleButton sx={{ mr: 1 }} />

          <IconButton color="inherit" onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
          <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            {DrawerList}
          </Drawer>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminTopBar;
